// Shipping Constants

export const SET_SHIPPING_INFO = 'SET_SHIPPING_INFO';